import { z } from 'zod';

import {
  QUIZ_TERM_MAX,
  QUIZ_USER_COUNT_MAX,
  QUOTE_PLAN_TYPES,
  QUOTE_PLANS,
} from '../constants/quizQuote.const';

import { quoteDateSchema } from './quoteDate';

/** onzep 견적 폼과 동일: 휴대폰, 유선(02/03~06), 070, 대표번호(15xx~19xx) */
const KR_PHONE_RE =
  /^(01[016789]-?\d{3,4}-?\d{4}|02-?\d{3,4}-?\d{4}|0[3-6]\d-?\d{3,4}-?\d{4}|070-?\d{3,4}-?\d{4}|1[5-9]\d{2}-?\d{4})$/;

/**
 * 견적 폼 스키마 — 입력 형식·상한·동의 검증의 단일 소스.
 * 요금 유형 자격과 가격은 Quiz 서버가 최종 판정한다.
 */
export const quizQuoteSchema = z.object({
  school_name: z
    .string()
    .trim()
    .min(1, '학교·기관명을 입력해 주세요.')
    .max(255),
  account_name: z.string().trim().min(1, '담당자명을 입력해 주세요.').max(255),
  account_phone: z
    .string()
    .trim()
    .regex(KR_PHONE_RE, '올바른 연락처를 입력해 주세요.')
    .max(20),
  account_email: z
    .string()
    .trim()
    .min(1, '이메일을 입력해 주세요.')
    .min(3, '이메일을 3자 이상 입력해 주세요.')
    .email('올바른 이메일을 입력해 주세요.')
    .max(255),
  plan: z.enum(QUOTE_PLANS),
  plan_type: z.enum(QUOTE_PLAN_TYPES),
  user_count: z
    .number({ invalid_type_error: '이용 인원을 입력해 주세요.' })
    .int()
    .min(1, '이용 인원을 입력해 주세요.')
    .max(QUIZ_USER_COUNT_MAX),
  term: z
    .number({ invalid_type_error: '이용 기간을 입력해 주세요.' })
    .int()
    .min(1, '이용 기간을 입력해 주세요.')
    .max(QUIZ_TERM_MAX),
  start_date: quoteDateSchema,
  annotation: z.string().trim().max(500).default(''),
  consent: z
    .boolean()
    .refine(v => v === true, '개인정보 수집·이용에 동의해 주세요.'),
});

export type QuizQuoteFormValues = z.infer<typeof quizQuoteSchema>;
